import { useCallback, useContext, useEffect } from "react";
import { LightBoxApiContext } from "./context";

export function useLightBox(
  src: string | undefined,
  alt: string
): {
  open: () => void;
} {
  const {
    addImage,
    removeImage,
    open: openImage,
  } = useContext(LightBoxApiContext);
  useEffect(() => {
    if (src === undefined) {
      return;
    }

    addImage(src, alt);
    return () => {
      removeImage(src);
    };
  }, [addImage, removeImage, src, alt]);

  const open = useCallback(
    () => src !== undefined && openImage(src),
    [openImage, src]
  );

  return {
    open,
  };
}
